import { CarouselItem } from '@browsing/get-inspired';
import { SHOWSTOPPER_FIXED_POSITION } from '@client/config/constants';
import { buildCampaignUrl } from '@client/helpers/campaignUrl';
import { Campaign, Showstopper } from '@shared/types/mylounge';

export interface ShowstopperMedia {
    type: string;
    desktop: string;
    mobile: string;
}
export interface ShowstopperContent {
    title: string;
    content: string;
    campaigns: CarouselItem[];
    position?: number;
    media: ShowstopperMedia;
}

export const buildShowstopperContent: (
    showstopper: Showstopper,
    openCampaigns: Campaign[],
) => ShowstopperContent = (showstopper: Showstopper, openCampaigns: Campaign[]) => {
    if (!showstopper) {
        return undefined;
    }
    const showstopperCampaigns = openCampaigns.filter((campaign: Campaign) =>
        campaign.showstopperIds.includes(showstopper?.id),
    );

    const showstopperCarouselCampaigns = showstopperCampaigns.map((campaign: Campaign) => ({
        brand: campaign.name,
        commodityGroup: '',
        discount: campaign.discount?.maxDiscount,
        images: campaign.images.mobile,
        url: buildCampaignUrl(campaign.campaignId),
        dateTill: Date.parse(campaign.endsAt),
    }));

    return {
        title: showstopper.title,
        content: showstopper.content,
        campaigns: showstopperCarouselCampaigns,
        media: {
            type: 'IMAGE',
            desktop: showstopper.image,
            mobile: showstopper.image,
        },
        position: SHOWSTOPPER_FIXED_POSITION,
    };
};
